import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ISensor } from 'app/shared/model/sensor.model';
import { getEntities as getSensors } from 'app/entities/sensor/sensor.reducer';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { IVehiclePosition } from 'app/shared/model/vehicle-position.model';
import { getEntities as getVehiclePositions } from 'app/entities/vehicle-position/vehicle-position.reducer';
import { getEntity, updateEntity, createEntity, reset } from './sensor-data.reducer';
import { ISensorData } from 'app/shared/model/sensor-data.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SensorDataUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const sensors = useAppSelector(state => state.sensor.entities);
  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  /* const companies = useAppSelector(state => state.company.entities); */
  const users = useAppSelector(state => state.userManagement.users);
  const vehiclePositions = useAppSelector(state => state.vehiclePosition.entities);
  const sensorDataEntity = useAppSelector(state => state.sensorData.entity);
  const loading = useAppSelector(state => state.sensorData.loading);
  const updating = useAppSelector(state => state.sensorData.updating);
  const updateSuccess = useAppSelector(state => state.sensorData.updateSuccess);

  const handleClose = () => {
    props.history.push('/sensor-data' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getSensors({}));
    dispatch(getTruckImplements({}));
    /* dispatch(getCompanies({})); */
    dispatch(getUsers({}));
    dispatch(getVehiclePositions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...sensorDataEntity,
      ...values,
      sensor: sensors.find(it => it.id.toString() === values.sensorId.toString()),
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      /* company: companies.find(it => it.id.toString() === values.companyId.toString()), */
      user: users.find(it => it.id.toString() === values.userId.toString()),
      vehiclePosition: vehiclePositions.find(it => it.id.toString() === values.vehiclePositionId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...sensorDataEntity,
          created: convertDateTimeFromServer(sensorDataEntity.created),
          sensorId: sensorDataEntity?.sensor?.id,
          truckImplementId: sensorDataEntity?.truckImplement?.id,
          /* companyId: sensorDataEntity?.company?.id, */
          userId: sensorDataEntity?.user?.id,
          vehiclePositionId: sensorDataEntity?.vehiclePosition?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.sensorData.home.createOrEditLabel" data-cy="SensorDataCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.sensorData.home.createOrEditLabel">Create or edit a SensorData</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="sensor-data-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.sensorData.value')}
                id="sensor-data-value"
                name="value"
                data-cy="value"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.sensorData.created')}
                id="sensor-data-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="sensor-data-sensor"
                name="sensorId"
                data-cy="sensor"
                label={translate('fleetSenseApp.sensorData.sensor')}
                type="select"
              >
                {isNew ? <option value="" key="0" /> : null}
                {sensors
                  ? sensors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="sensor-data-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.sensorData.truckImplement')}
                type="select"
              >
                {isNew ? <option value="" key="0" /> : null}
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              {/* <ValidatedField
                id="sensor-data-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.sensorData.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField> */}
              <ValidatedField
                id="sensor-data-user"
                name="userId"
                data-cy="user"
                label={translate('fleetSenseApp.sensorData.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="sensor-data-vehiclePosition"
                name="vehiclePositionId"
                data-cy="vehiclePosition"
                label={translate('fleetSenseApp.sensorData.vehiclePosition')}
                type="select"
              >
                <option value="" key="0" />
                {vehiclePositions
                  ? vehiclePositions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.created}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/sensor-data" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SensorDataUpdate;
